import React from 'react'

import Avatar from 'common/components/dataDisplay/Avatar'

import './EmployeeDetails.less'

interface UserAvatarProps {
  firstName: string
  lastName: string
}

const UserAvatar: React.FC<UserAvatarProps> = ({ firstName, lastName }) => {
  return (
    <div className="flex__space_between">
      <div className="flex align-center">
        <Avatar shape="circle" size="large" text={firstName[0] + lastName[0]} className="user_icon mr-16" />
        <h4 className="mb-0">
          {firstName} {lastName}
        </h4>
      </div>
    </div>
  )
}

export default UserAvatar
